import(/* webpackMode: "eager" */ "/vercel/path0/src/app/novel/page.tsx");
